"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Composition = _interopRequireDefault(require("composer-lib/data/model/Composition"));

var _ComposerToolbarGroup = _interopRequireDefault(require("composer-lib/components/composer/ComposerToolbarGroup"));

var _reactRedux = require("react-redux");

var _PresenceContainer = _interopRequireDefault(require("composer-lib/containers/presence/PresenceContainer"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _ShareButtonContainer = _interopRequireDefault(require("composer-lib/containers/composer/ShareButtonContainer"));

var _WordCountContainer = _interopRequireDefault(require("composer-lib/containers/composer/WordCountContainer"));

var mapStateToProps = function mapStateToProps(state) {
  return {
    composition: state.composition
  };
};

var ToolbarRowContainer = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ToolbarRowContainer, _Component);

  function ToolbarRowContainer() {
    (0, _classCallCheck2.default)(this, ToolbarRowContainer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ToolbarRowContainer).apply(this, arguments));
  }

  (0, _createClass2.default)(ToolbarRowContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          addKeyCommandListener = _this$props.addKeyCommandListener,
          composition = _this$props.composition,
          handleKeyCommand = _this$props.handleKeyCommand,
          removeKeyCommandListener = _this$props.removeKeyCommandListener;

      if (composition.isReadOnly()) {
        return null;
      }

      return _react.default.createElement(_ComposerToolbarGroup.default, {
        addKeyCommandListener: addKeyCommandListener,
        className: "toolbar-row-container",
        handleKeyCommand: handleKeyCommand,
        left: _react.default.createElement(_PresenceContainer.default, null),
        removeKeyCommandListener: removeKeyCommandListener,
        right: [_react.default.createElement(_WordCountContainer.default, {
          key: "word-count",
          useLineHeight: true
        }), _react.default.createElement(_ShareButtonContainer.default, {
          className: "m-left-2",
          key: "share-button"
        })]
      });
    }
  }]);
  return ToolbarRowContainer;
}(_react.Component);

ToolbarRowContainer.propTypes = {
  addKeyCommandListener: _propTypes.default.func.isRequired,
  composition: _propTypes.default.instanceOf(_Composition.default).isRequired,
  handleKeyCommand: _propTypes.default.func.isRequired,
  removeKeyCommandListener: _propTypes.default.func.isRequired
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(ToolbarRowContainer);

exports.default = _default;
module.exports = exports.default;